export function sanitizeBlockHtml(html: string): string {
  const source = html || ''
  return source
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
    .replace(/on\w+=["'][^"']*["']/gi, '')
    .replace(/javascript:/gi, '')
}
